import dataUtil from '@/utils/data'

const camelToSnake = string => {

    return string.replace(/[\w]([A-Z])/g, function(m) {

        return m[0] + "_" + m[1]
    }).toLowerCase()
}

const camelObjectKeysToSnake = obj => {

    const newObj = {}

    for (const key in obj) {

        newObj[camelToSnake(key)] = obj[key]
    }

    return newObj
}

const camelObjectKeysToSnakeRecursive = obj => {

    if ((obj instanceof File) || (obj instanceof Date)) {

        return obj
    }
    else if (dataUtil.isObject(obj)) {

        const newObj = {}

        Object.keys(obj).forEach(k => {

            newObj[camelToSnake(k)] = camelObjectKeysToSnakeRecursive(obj[k])
        })

        return newObj
    }
    else if (Array.isArray(obj)) {

        return obj.map(m => camelObjectKeysToSnakeRecursive(m))
    }

    return obj;
}

const snakeToCamel = string => {

    return string.replace(/([-_][a-z0-9])/ig, ($1) => {

        return $1.toUpperCase()
            .replace('-', '')
            .replace('_', '')
    })
}

const snakeObjectKeysToCamel = obj => {

    const newObj = {}

    for (const key in obj) {

        newObj[snakeToCamel(key)] = obj[key]
    }

    return newObj
}

const snakeObjectKeysToCamelRecursive = obj => {

    if ((obj instanceof File) || (obj instanceof Date)) {

        return obj
    }
    else if (dataUtil.isObject(obj)) {

        const newObj = {}

        Object.keys(obj).forEach(k => {

            newObj[snakeToCamel(k)] = snakeObjectKeysToCamelRecursive(obj[k])
        })

        return newObj
    }
    else if (Array.isArray(obj)) {

        return obj.map(m => snakeObjectKeysToCamelRecursive(m))
    }

    return obj;
}

export default {
    camelToSnake,
    camelObjectKeysToSnake,
    camelObjectKeysToSnakeRecursive,
    snakeToCamel,
    snakeObjectKeysToCamel,
    snakeObjectKeysToCamelRecursive
}